<template>
  <div id="app" class="didi">
    <div class="bg" />
    <header class="mobile">
      <a class="logo silent" href="/">
        <img src="../assets/logo__24011701.svg" />
      </a>
      <i
        class="material-icons nav-opener"
        :class="{ open: navOpen }"
        @click="navOpen = !navOpen"
        >menu</i
      >
    </header>
    <header>
      <div>
        <a class="logo silent" href="/" style="padding: 20px 0">
          <img src="../assets/logo__24011701.svg" />
        </a>
        <div>
          <p>
            Nicht die richtige Party?
            <span style="margin-right: 20px" />
            <button @click="toggleLocationChooser">Location wechseln</button>
          </p>
        </div>
      </div>
      <router-link :to="{ name: 'ticket' }" class="silent">
        <PartyCircles class="facts" />
      </router-link>
      <div class="actions-wrapper">
        <div>
          <template v-if="countdownLast > 0 || !ticketsAvailable">
            <template v-if="countdownLast > 0">
              <h3 style="margin: 0">
                {{ $t("ticketSaleStartsIn") }}
              </h3>
              <div class="countdown">
                <template v-if="countdownDays >= 1">
                  {{ countdownDays }} {{ $tc("day", countdownDays) }},
                  {{ countdownHours }} {{ $tc("hour", countdownHours) }}
                </template>
                <template v-else>
                  {{ countdownHours }}:{{ countdownMins }}:{{ countdownSecs }}
                </template>
              </div>
              ({{ ticketSaleStart.toLocaleString() }})
            </template>
            <!-- <h3 v-else>{{ $t("actions.soldOut") }}</h3> -->
          </template>
        </div>
        <div class="actions">
          <a
            class="button"
            disabled
            v-if="countdownLast > 0 || !ticketSaleStartDateKnown"
            >{{ $t("actions.ticket") }}</a
          >
          <router-link
            v-else-if="ticketsAvailable"
            :to="{ name: 'ticket' }"
            class="button"
            >{{ $t("actions.ticket") }}</router-link
          >
          <a href="https://pupstyle.de/frechdax" class="button internal"
            >Merch</a
          >
          <router-link :to="{ name: 'newsletter' }" class="button">{{
            $t("actions.newsletter")
          }}</router-link>
        </div>
      </div>
    </header>
    <main>
      <aside>
        <div class="flyer">
          <a
            class="silent"
            href="/flyer/flyer_2025-10-11_001-full.jpg"
            target="_blank"
          >
            <img
              src="/flyer/flyer_2025-10-11_001-thumb.jpg"
              style="border-radius: 8px"
          /></a>
          <p>
            {{ $t("meet_and_greet") }}
          </p>
        </div>

        <nav :class="{ open: navOpen }">
          <div class="close" @click="navOpen = false">
            <i class="material-icons">close</i>CLOSE MENU
          </div>
          <template v-for="navItem in NAVIGATION">
            <router-link
              v-if="
                (navItem.public &&
                  (navItem.name !== 'ticket' || ticketsAvailable)) ||
                false
              "
              v-bind:to="{ name: navItem.name, params: navItem.params }"
            >
              <i class="material-icons">
                {{ navItem.icon }}
              </i>
              {{ $t(navItem.title) }}
            </router-link>
            <a v-else disabled>
              <i class="material-icons">
                {{ navItem.icon }}
              </i>
              {{ $t(navItem.title) }}
              <div style="font-size: 80%; font-weight: normal">
                Coming soon!
              </div>
            </a>
          </template>
        </nav>
        <div class="partners">
          <h3 style="text-align: center">Unterstützt durch</h3>
          <div class="partner-links">
            <a class="silent" href="https://www.mlc-munich.de/">
              <img src="../assets/mlc.jpg" />
            </a>
            <a class="silent" href="https://eu.abuniverse.com/">
              <img src="../assets/partner_abu.svg" />
            </a>
          </div>
          <div class="partner-links" style="margin-top: 20px">
            <a class="silent" href="https://t.me/+MMoQ8jmWnpw3ZGQy">
              <img src="../assets/telegram.png" />
            </a>
            <a class="silent" href="https://x.com/frechdax_abdl">
              <img src="../assets/twitter.png" />
            </a>
            <a
              class="silent"
              href="https://www.instagram.com/frechdax_abdlparty/"
            >
              <img src="../assets/instagram.png" />
            </a>
          </div>
        </div>
      </aside>
      <div id="main-content-anchor"></div>
      <div class="content" id="main-content">
        <router-view></router-view>
      </div>
    </main>
    <footer>
      <p class="language-select">
        <a
          class="silent"
          @click="setLocale('de')"
          :class="{
            selected: $i18n.locale === 'de',
          }"
          >Deutsch</a
        >
        &nbsp;
        <a
          class="silent"
          @click="setLocale('en')"
          :class="{
            selected: $i18n.locale === 'en',
          }"
          >English</a
        >
      </p>

      &copy; 2019-2025 Alle Rechte vorbehalten. <br />
      <router-link class="silent" :to="{ name: 'impressum' }"
        >Impressum</router-link
      >
      |
      <router-link class="silent" :to="{ name: 'privacy' }"
        >Datenschutz</router-link
      >
      |
      <a class="silent" :href="authURL">Teamlogin</a>
      <br />
      <p style="display: inline-flex; align-items: center; grid-gap: 0.5em">
        <span>Made with</span>
        <i class="material-icons">favorite</i>
        <span>by Nevoky Volth</span>
      </p>
    </footer>
    <div class="profile" v-if="user">
      <div
        class="avatar"
        :style="{ backgroundImage: `url(${user.avatar_url})` }"
      ></div>
      <label>{{ user.name }}</label>
      <button @click="logout"><i class="material-icons">logout</i></button>
    </div>
    <location-chooser
      v-bind:class="{ visible: locationChooserActive }"
      v-on:close="locationChooserActive = false"
    />
  </div>
</template>

<script>
import axios from "axios";
import PartyCircles from "@/components/PartyCircles.vue";
import LocationChooser from "@/components/location-chooser";
import NAVIGATION from "@/data/navigation.yml";
import dynamicLocalization from "@/mixins/dynamic-localization";

const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);

export default {
  components: { PartyCircles, LocationChooser },
  mixins: [dynamicLocalization],
  data() {
    const ticketSaleStartDate = new Date(
      Date.UTC(
        TICKET_SALE_START.year,
        TICKET_SALE_START.month - 1,
        TICKET_SALE_START.day,
        TICKET_SALE_START.hour + TICKET_SALE_START.utcOffset,
        0
      )
    );

    const ticketSaleStartDateKnown =
      process.env.VUE_APP_TICKET_SALE_START !=
      process.env.VUE_APP_NEXT_PARTY_DATE;
    const now = new Date();

    return {
      ticketSaleStart: ticketSaleStartDateKnown ? ticketSaleStartDate : now,
      now: now,
      navOpen: false,
      twitterActive: false,
      authURL: process.env.VUE_APP_AUTH_URL,
      user: null,
      showTicketNote: true,
      ticketsAvailable: process.env.VUE_APP_TICKETS_AVAILABLE === "true",
      ticketSaleStartDateKnown,
      locationChooserActive:
        this.$route.name == "start" &&
        !process.env.VUE_APP_STAGE.startsWith("dev/"),
      NAVIGATION,
    };
  },
  created() {
    window.setInterval(() => {
      this.now = new Date();
    }, 300);
  },
  mounted() {
    this.authenticate();
  },
  computed: {
    countdownLast() {
      return this.ticketSaleStart - this.now;
    },
    countdownDays() {
      // 1000 msecs * 60 secs * 60 mins * 24 hours = 86400000
      return Math.floor(this.countdownLast / 86400000);
    },
    countdownHours() {
      // 1000 msecs * 60 secs * 60 mins = 3600000
      let res = Math.floor(this.countdownLast / 3600000) % 24;
      return res < 10 ? "0" + res : res;
    },
    countdownMins() {
      // 1000 msecs * 60 secs = 600000
      let res = Math.floor(this.countdownLast / 60000) % 60;
      return res < 10 ? "0" + res : res;
    },
    countdownSecs() {
      // 1000 msecs
      let res = Math.floor(this.countdownLast / 1000) % 60;
      return res < 10 ? "0" + res : res;
    },
    countdownMSecs() {
      let res = Math.floor(this.countdownLast / 10) % 100;
      return res < 10 ? "0" + res : res;
    },
  },
  methods: {
    activateTwitter(e) {
      if (!this.twitterActive) {
        if (
          confirm(
            "Durch die Aktivierung des Tweet-Buttons werden Cookies von Twitter gespeichert. Forfahren?"
          )
        ) {
          window.twttr = (function (d, s, id) {
            var js,
              fjs = d.getElementsByTagName(s)[0],
              t = window.twttr || {};
            if (d.getElementById(id)) {
              return t;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
              t._e.push(f);
            };

            return t;
          })(document, "script", "twitter-wjs");
          this.twitterActive = true;
        }
        e.stopPropagation();
        return false;
      }
    },
    authenticate() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      if (credentials) {
        axios
          .get(`${process.env.VUE_APP_API}/auth/profile`, {
            headers: {
              Authorization: `Bearer ${credentials.auth.access_token}`,
            },
            params: {
              id: credentials.info.resource_owner_id,
            },
          })
          .then((response) => {
            this.user = response.data;
          });
      }
    },
    logout() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      axios
        .post(`${process.env.VUE_APP_API}/auth/logout`, {
          token: credentials.auth.access_token,
        })
        .then((response) => {
          this.user = null;
          localStorage.removeItem("API_CREDENTIALS");
          this.$router.go();
        });
    },
    setLocale(locale) {
      localStorage.setItem("LOCALE", locale);
      this.$root.$i18n.locale = locale;
    },

    toggleLocationChooser() {
      this.locationChooserActive = !this.locationChooserActive;
    },
  },
  watch: {
    $route() {
      // Whenever route changes, close the mobile nav, i.e. user clicked a link
      this.navOpen = false;
      this.authenticate();
    },
  },
};
</script>

<style lang="scss" src="./Didi.scss" />

<i18n>
{
  "de": {
    "facts": {
      "anniversary_edition": "MLC Jubiläumsedition",
      "party_date": "Play & Pamper // 23. März 2024",
      "location": "UnderGround München",
      "meet_and_greet": "Meet & Greet // 22. März 2024 // 19-22 Uhr // Café Sub",
      "dance_and_diaper": "Dance & Diaper // 22. März 2024 // 23-5 Uhr // Milla Club",
      "brunch_and_byebye": "Brunch & ByeBye // 24. März 2024 // 11-14 Uhr // Wirtshaus Fesch"
    },
    "actions": {
      "ticketNote": "Ticketverkauf startet bald!",
      "soldOut": "Party ausverkauft!",
      "newsletter": "Newsletter",
      "ticket": "Ticket kaufen"
    },
    "flyer": {
      "share": "Erzählt euren Freunden von der Party",
      "download": "Flyer herunterladen & teilen",
      "twitter": "Per Twitter teilen"
    },
    "meet_and_greet": "Besuche uns am Freitag beim Meet & Greet im Café Sub - auch ohne Ticket!",
    "navigation": {
      "start": "Brief von Didi",
      "save_the_date": "Save the Date",
      "ticket": "Ticket",
      "party": "Die Party",
      "faq": "Mehr Infos",
      "directions": "Anfahrt",
      "recommendations": "Empfehlungen",
      "contact": "Kontakt"
    },
    "ticketSaleStartsIn": "Ticketverkauf startet in",
    "day": "Tag | Tagen",
    "hour": "Stunde | Stunden"
  },

  "en": {
    "facts": {
      "anniversary_edition": "MLC Anniversary Edition",
      "party_date": "Play & Pamper // March 23, 2024",
      "location": "UnderGround Munich",
      "meet_and_greet": "Meet & Greet // March 22, 2024 // 7-10 PM CEST // Café Sub",
      "dance_and_diaper": "Dance & Diaper // March 22, 2024 // 11 PM - 5 AM CEST // Milla Club",
      "brunch_and_byebye": "Brunch & ByeBye // March 24, 2024 // 11 AM - 2 PM CEST // Wirtshaus Fesch"
    },
    "actions": {
      "ticketNote": "Ticket sale starts soon!",
      "soldOut": "Party sold out!",
      "newsletter": "Newsletter",
      "ticket": "Get Your Ticket"
    },
    "flyer": {
      "share": "Tell your friends about this party",
      "download": "Download Flyer & Share",
      "twitter": "Share via Twitter"
    },
    "meet_and_greet": "Meet us on Friday at the Meet & Greet in Café Sub - no ticket needed!",
    "navigation": {
      "start": "Letter From Didi",
      "save_the_date": "Save the Date",
      "ticket": "Ticket",
      "party": "The Party",
      "faq": "More Info",
      "directions": "Directions",
      "recommendations": "Recommendations",
      "contact": "Contact"
    },
    "ticketSaleStartsIn": "Ticket sale starts in",
    "day": "day | days",
    "hour": "hour | hours"
  }
}
</i18n>
